import { Trip } from '@/typing/api/tripNew.class';
import MaterialIcon from '@/typing/enums/materialIcon.enum';
import Role from '@/typing/enums/role.enum';
import { TripStatus } from '@/typing/enums/tripStatus.enum';
import $dayjs from '@/utils/dayjs';

export function determineFilterItems(userRole: Role): any[] {
    const items = [];

    items.push({
        label: 'Geen status filter (actie vereist)',
        value: (item: Trip) => {
            if (userRole === Role.Skipper) {
                return (
                    item.status === TripStatus.OpenSkipper ||
                    item.status === TripStatus.RejectedContractor
                );
            }

            if (userRole === Role.Contractor) {
                return (
                    item.status === TripStatus.OpenContractor ||
                    item.status === TripStatus.RejectedClient ||
                    item.status === TripStatus.RejectedContractor
                );
            }

            if (userRole === Role.Client) {
                return item.status === TripStatus.OpenClient;
            }
        },
        icon: MaterialIcon.Filter,
    });

    if (userRole === Role.Client) {
        items.push({
            label: 'Ingediend',
            value: (item: Trip) => item.status === TripStatus.OpenClient,
            icon: MaterialIcon.Send,
        });
        items.push({
            label: 'Afgekeurd',
            value: (item: Trip) => item.status === TripStatus.RejectedClient,
            icon: MaterialIcon.Close,
        });
        items.push({
            label: 'Goedgekeurd',
            value: (item: Trip) => item.status === TripStatus.ApprovedClient,
            icon: MaterialIcon.Done,
        });
    } else if (userRole === Role.Contractor) {
        items.push({
            label: 'Open',
            value: (item: Trip) => item.status === TripStatus.OpenContractor,
        });
        items.push({
            label: 'Afgekeurd door opdrachtgever',
            value: (item: Trip) => item.status === TripStatus.RejectedClient,
            icon: MaterialIcon.Close,
        });
        items.push({
            label: 'Afgekeurd door aannemer',
            value: (item: Trip) =>
                item.status === TripStatus.RejectedContractor,
            icon: MaterialIcon.Close,
        });
    } else if (userRole === Role.Skipper) {
        items.push({
            label: 'Open',
            value: (item: Trip) => item.status === TripStatus.OpenSkipper,
        });
        items.push({
            label: 'Afgekeurd',
            value: (item: Trip) =>
                item.status === TripStatus.RejectedContractor,
            icon: MaterialIcon.Close,
        });
    }

    items.push({
        label: 'Afgelopen 7 dagen',
        value: (item: Trip) => {
            const maxShownDate = $dayjs().subtract(7, 'days').startOf('day');
            const date = $dayjs(item.startTimeDate);

            return !date.isValid() || date.valueOf() > maxShownDate.valueOf();
        },
    });

    return items;
}
